const clientModeOptions = [
    { value: 1, label: '連線' },
    { value: 2, label: '連線 + 單機' },
];

export default clientModeOptions;
